/*
 * Home hero slider.
 *
 * Replaces Bootstrap's carousel. The track is a scroll-snap strip, so the slides
 * are swipeable and keyboard-scrollable with no JavaScript at all; this element
 * only adds the previous/next buttons and keeps their disabled state honest.
 *
 * Deliberately not ported from the original: autoplay. `data-bs-ride="carousel"`
 * moved the hero every few seconds, which is a WCAG 2.2.2 problem (moving content
 * with no pause control) and consistently tests badly. Reintroducing it should be
 * a decision, not an accident of the port.
 */
class LbSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.lb-slider__track');
    if (!this.track) return;

    this.previous = this.querySelector('[data-lb-slider-prev]');
    this.next = this.querySelector('[data-lb-slider-next]');
    if (!this.previous || !this.next) return;

    this.previous.addEventListener('click', () => this.scrollByOneSlide(-1));
    this.next.addEventListener('click', () => this.scrollByOneSlide(1));

    this.track.addEventListener('scroll', this.syncControls, { passive: true });
    this.syncControls();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.syncControls);
  }

  scrollByOneSlide(direction) {
    const slide = this.track.querySelector('.lb-slider__slide');
    if (!slide) return;

    this.track.scrollBy({
      left: slide.getBoundingClientRect().width * direction,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  // Fires on every scroll frame, so it must stay cheap: two reads, no layout writes.
  syncControls = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    // Sub-pixel scroll positions mean the ends never land exactly on 0 or the max.
    const epsilon = 2;

    this.previous.disabled = scrollLeft <= epsilon;
    this.next.disabled = scrollLeft >= scrollWidth - clientWidth - epsilon;
  };
}

customElements.define('lb-slider', LbSlider);
